import React from 'react';
import InputAdornment from '@material-ui/core/InputAdornment';

import { Tooltip } from 'core/components/tooltip';

// Build an InputAdornment with an info icon for input-style field types
// (numeric / string / textarea / select) when their tooltipText prop is set.
// Mirrors the tooltip rendering that switch / checkbox / radio already do
// for the same prop pair — when tooltipLabel is provided the underlying
// Tooltip swaps the icon for clickable text (matching switch.jsx). Returns
// undefined when tooltipText is empty so callers can leave the
// InputProps.endAdornment slot untouched. (#30648)
export const buildTooltipAdornment = (tooltipText, tooltipLabel) => {
  if (!tooltipText) {
    return undefined;
  }
  return (
    <InputAdornment position="end">
      <Tooltip text={tooltipText} label={tooltipLabel} placement="top" smallIcon />
    </InputAdornment>
  );
};
